import React from "react";
import "../styles/loading.scss";
export const Loading = () => {
  return (
    <div className="loading">
      <div className="parent">
        <div className="child"/>
      </div>
    </div>
  );
};
